import { combineReducers } from 'redux';

import constructionByApplication from './constructionByApplication.reducer';

export default combineReducers({
  constructionByApplication,
});
